import axiosInstance, { errorHandler } from "./api";

// BankPropertyResource.getBatchSign
const getProperties = axios => () =>
  axios
    .get("/tps/api/properties")
    .then(({ data: { data } }) => data)
    .catch(errorHandler);

// No permission
const getBankInfo = axios => () =>
  axios
    .get("/tps/api/properties/self-info")
    .then(({ data }) => data)
    .catch(errorHandler);

// BankPropertyResource.updateMobilTc
const sendTermsAndConditionsMobile = axios => text =>
  axios
    .post("/tps/api/properties/t-c-mobile", { text })
    .then(({ data: { data } }) => data)
    .catch(errorHandler);

// BankPropertyResource.updateDesktopTc
const sendTermsAndConditionsDesktop = axios => text =>
  axios
    .post("/tps/api/properties/t-c-desktop", { text })
    .then(({ data: { data } }) => data)
    .catch(errorHandler);

export default {
  getProperties: getProperties(axiosInstance),
  getBankInfo: getBankInfo(axiosInstance),
  sendTermsAndConditionsMobile: sendTermsAndConditionsMobile(axiosInstance),
  sendTermsAndConditionsDesktop: sendTermsAndConditionsDesktop(axiosInstance),
};
